'use strict';

var _regeneratorRuntime = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var dagPB = require('ipld-dag-pb');

var dagCBOR = require('ipld-dag-cbor');

var raw = require('ipld-raw');

var configure = require('../lib/configure');

var resolvers = {
  'dag-cbor': dagCBOR.resolver,
  'dag-pb': dagPB.resolver,
  raw: raw.resolver
};
module.exports = configure(function (api, options) {
  var getBlock = require('../block/get')(options);

  var dagResolve = require('./resolve')(options);

  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(cid, path) {
        var options,
            resolved,
            block,
            dagResolver,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};

                if (path && typeof path === 'object') {
                  options = path;
                  path = null;
                }

                _context.next = 4;
                return dagResolve(cid, path, options);

              case 4:
                resolved = _context.sent;
                _context.next = 7;
                return getBlock(resolved.cid, options);

              case 7:
                block = _context.sent;
                dagResolver = resolvers[block.cid.codec];

                if (dagResolver) {
                  _context.next = 11;
                  break;
                }

                throw Object.assign(new Error("Missing IPLD format \"".concat(block.cid.codec, "\"")), {
                  missingMulticodec: cid.codec
                });

              case 11:
                return _context.abrupt("return", dagResolver.resolve(block.data, resolved.remPath));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
});